<template>
  <div class="warp">
    <div class="detail">
      <h3 class="title">{{ detail.title }}</h3>
      <div class="content" v-html="detail.content"></div>
    </div>
    <el-button class="but" type="primary" @click="toBack"> 关闭</el-button>
  </div>
</template>
<script>
import Bus from "@/api/bus"; 
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: {},
  data() {
    return {
      detail: {}
    };
  },
  created() {
    // 移除可能导致重复导航的事件触发
    this.fetchAgreementDetails();
  },
  methods: {
    fetchAgreementDetails() {
      homeClient.getAgreementDetails( 1)
        .then((res) => {
          if (  res.code == 0  ) {
            this.detail = res.data;
          }
        })
        .catch((error) => {
          console.error('获取协议详情失败:', error);
        });
    },
    toBack() {
      this.$router.push("/");
    }
  }
};
</script>
<style lang="less" scoped>
.warp {
  padding: 20px 0;
  background: #fff;
}
.detail {
  width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background: #fff;
  .title {
    text-align: center;
    margin-bottom: 20px;
  }
}
.but {
  margin: 20px auto;
  display: block;
}
</style>
